import { render, staticRenderFns } from "./ForumAddThread.vue?vue&type=template&id=954795b6&"
import script from "./ForumAddThread.vue?vue&type=script&lang=js&"
export * from "./ForumAddThread.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports